import { useBanner } from '~/hooks/useBanner'
import { cn } from '~/utils/tailwind-utils'

export const SidebarContainer = ({
  children,
  className,
}: {
  className?: string
  children: React.ReactNode
}) => {
  const { showBanner } = useBanner()

  return (
    <div
      className={cn([
        className,
        // border and background
        'border-gray-150 border-r bg-gray-50 dark:border-gray-800 dark:bg-gray-900',
        // layout and size
        'sticky left-0 z-[19] hidden w-56 shrink-0 md:block',
        showBanner ? 'top-10 h-[calc(100dvh-2.5rem)]' : 'top-0 h-dvh', // Move the sidebar down if a banner is shown
      ])}
    >
      {children}
    </div>
  )
}
